import api from "@/api/index";

export const rappelService = {
  async getGroupedRemindersByOwners(search = "") {
    try {
      const params = search ? { search } : {};
      const response = await api.get("/ration-reminders/grouped-by-owners", { params });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des rappels groupés:", error);
      throw error;
    }
  },

  async getReminder(id) {
    try {
      const response = await api.get(`/ration-reminders/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du rappel ${id}:`, error);
      throw error;
    }
  },

  async createReminder(reminderData) {
    try {
      const response = await api.post("/ration-reminders", reminderData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du rappel:", error);
      throw error;
    }
  },

  async updateReminder(id, updateData) {
    try {
      const response = await api.put(`/ration-reminders/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du rappel ${id}:`, error);
      throw error;
    }
  },

  async deleteReminder(id) {
    try {
      await api.delete(`/ration-reminders/${id}`);
    } catch (error) {
      console.error(`Erreur lors de la suppression du rappel ${id}:`, error);
      throw error;
    }
  },

  validateReminderData(reminderData) {
    const errors = {};
    let isValid = true;

    if (!reminderData.ownerId) {
      errors.ownerId = "Le propriétaire est obligatoire";
      isValid = false;
    }

    if (!reminderData.productVariantId) {
      errors.productVariantId = "Le produit est obligatoire";
      isValid = false;
    }

    if (!reminderData.rationJournaliere || reminderData.rationJournaliere <= 0) {
      errors.rationJournaliere = "La ration journalière doit être supérieure à 0";
      isValid = false;
    }

    if (!reminderData.dateMiseEnPlace) {
      errors.dateMiseEnPlace = "La date de mise en place est obligatoire";
      isValid = false;
    } else {
      const date = new Date(reminderData.dateMiseEnPlace);
      if (isNaN(date.getTime())) {
        errors.dateMiseEnPlace = "Format de date invalide";
        isValid = false;
      }
    }

    if (!reminderData.notificationType || reminderData.notificationType.length === 0) {
      errors.notificationType = "Au moins un type de notification est requis";
      isValid = false;
    }

    return { isValid, errors };
  },
};
